<h2 mat-dialog-title>
  {{ 'settingsSubjectLocationEditDialog.' + (isEdit ? "editLocation" : "addLocation") | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="start center">
  <div class="form-container" fxLayout="column" fxLayoutGap="5px">
    <mat-form-field>
      <mat-label>{{ 'settingsSubjectLocationEditDialog.identifierPlaceholder' | translate }}</mat-label>
      <input matInput [value]="identifierPrefix + abbreviationControl.value"
        disabled>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'settingsSubjectLocationEditDialog.namePlaceholder' | translate }}</mat-label>
      <input matInput maxlength="{{nameMaxLength}}" [formControl]="nameControl" required>
      <mat-hint align="end">{{nameControl.value?.length || 0}}/{{ nameMaxLength }}</mat-hint>
      <mat-error *ngIf="nameControl.hasError('required')">
        {{ 'settingsSubjectLocationEditDialog.nameRequired' | translate }}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('maxlength')">{{ 'settingsSubjectLocationEditDialog.nameMaxLength' | translate: {nameMaxLength: nameMaxLength} }}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('pattern') && !nameControl.hasError('required')">{{ 'settingsSubjectLocationEditDialog.nameValid' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ getPlaceholder('settingsSubjectLocationEditDialog.abbreviationPlaceholder' | translate) }}</mat-label>
      <input matInput maxlength="{{abbreviationMaxLength}}"
        [formControl]="abbreviationControl" required [disabled]="subjectModel.hasInspections">
      <mat-hint align="end">{{abbreviationControl.value?.length || 0}}/{{ abbreviationMaxLength }}</mat-hint>
      <mat-error *ngIf="abbreviationControl.hasError('required') && !abbreviationControl.hasError('space') && !abbreviationControl.hasError('dot')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationRequired' | translate }}
      </mat-error>
      <mat-error *ngIf="abbreviationControl.hasError('maxlength')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationMaxLength' | translate: {abbreviationMaxLength: abbreviationMaxLength} }}
      </mat-error>
      <mat-error *ngIf="abbreviationControl.hasError('pattern') && !abbreviationControl.hasError('required') && !abbreviationControl.hasError('space') && !abbreviationControl.hasError('dot')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationPattern' | translate }}
      </mat-error>
      <mat-error *ngIf="abbreviationControl.hasError('duplication') && !abbreviationControl.hasError('required')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationDuplication' | translate }}
      </mat-error>
      <mat-error *ngIf="abbreviationControl.hasError('space')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationSpace' | translate }}
      </mat-error>
      <mat-error *ngIf="abbreviationControl.hasError('dot')">
        {{ 'settingsSubjectLocationEditDialog.abbreviationDot' | translate }}
      </mat-error>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="start" [style.visibility]="isFirstLocation ? 'visible' : 'hidden'">
      <mat-slide-toggle color="primary" [disabled]="disabledDataPlateToggle()" (change)="initDataPlate()">
        <div> {{ 'settingsSubjectLocationEditDialog.dataPlate' | translate }} </div>
      </mat-slide-toggle>
      <mat-error class="dataplate-mat-error" *ngIf="disabledDataPlateToggle()">{{ 'settingsSubjectLocationEditDialog.dataPlateError' | translate }}</mat-error>
    </div>
    <ng-container *ngIf="!isDataPlateHidden()">
      <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
        <button mat-button color="primary" (click)="addInspectionFor()">
          <mat-icon style="margin: 0;">add_box</mat-icon>
        </button>
      </div>
      <div class="inspectionfor-container">
        <mat-table [dataSource]="inspectionForDataSource">
          <!-- Name Column -->
          <ng-container matColumnDef="inspectionFor">
            <mat-header-cell *matHeaderCellDef> {{ 'settingsSubjectLocationEditDialog.inspectionFor' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let inspectionFor; let i = index;">
              <div style="width: 100%;">
                <mat-form-field class="simple-mat-form-field inspection-for-input" floatLabel="never" fxFlex="grow">
                  <mat-label>{{ 'settingsSubjectLocationEditDialog.inspectionForPlaceholder' | translate }}</mat-label>
                  <input matInput maxlength="{{inspectionForMaxLength}}" [value]="inspectionFor"
                    [(ngModel)]="inspectionForDataSource.data[i]">
                </mat-form-field>
                <button mat-button color="warn" (click)="deleteInspectionFor(i)">
                  <mat-icon style="margin: 0;">delete</mat-icon>
                </button>
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="['inspectionFor']; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['inspectionFor'];"></mat-row>
        </mat-table>
      </div>
      <p class="rect-in-struct-image-title" *ngIf="isFirstLocation">
        {{ 'settingsSubjectLocationEditDialog.locationPosition' | translate }}</p>
      <div class="rect-in-struct-image-wrapper" *ngIf="isFirstLocation && subjectModel.structImagePath">
        <!--subject model locations-->
        <canvas #canvas [ngClass]="{ 'ghost-layer' : true }" [width]="ghostCanvasWidth" [height]="ghostCanvasHeight"
          (mousedown)="onBeginDraw($event)" (mouseup)="onEndDraw($event, 'Header')"></canvas>
        <img [src]="subjectModel.structImagePath" class="subject-cad-image" alt="dummyImage" />
        <div class="locations" *ngIf="!isRectInStructImageNoSetting()">
          <!-- area -->
          <div class="location-area" [style.top]="topControl.value + '%'" [style.left]="leftControl.value + '%'"
            [style.width]="widthControl.value + '%'" [style.height]="heightControl.value + '%'">&nbsp;
          </div>
        </div>
      </div>
      <div class="rect-in-struct-image-div" fxLayout="row" fxLayoutGap="10px" *ngIf="isFirstLocation">
        <mat-form-field>
          <mat-label>{{ 'settingsSubjectLocationEditDialog.topPlaceholder' | translate }}</mat-label>
          <input matInput maxlength="{{topMaxLength}}" [formControl]="topControl" required (focusout)="touchHeightControlCheck()">
          <mat-hint align="end">{{topControl.value?.length || 0}}/{{ topMaxLength }}</mat-hint>
          <mat-error *ngIf="topControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.topRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="topControl.hasError('maxlength')">{{ 'settingsSubjectLocationEditDialog.topMaxLength' | translate: {topMaxLength: topMaxLength} }}
          </mat-error>
          <mat-error *ngIf="topControl.hasError('pattern') && !topControl.hasError('required')">{{ 'settingsSubjectLocationEditDialog.topPattern' | translate }}</mat-error>
          <mat-error *ngIf="topControl.hasError('over') && !topControl.hasError('pattern') && !topControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.topOver' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'settingsSubjectLocationEditDialog.leftPlaceholder' | translate }}</mat-label>
          <input matInput maxlength="{{leftMaxLength}}" [formControl]="leftControl" required
            (focusout)="touchWidthControlCheck()">
          <mat-hint align="end">{{leftControl.value?.length || 0}}/{{ leftMaxLength }}</mat-hint>
          <mat-error *ngIf="leftControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.leftRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="leftControl.hasError('maxlength')">{{ 'settingsSubjectLocationEditDialog.leftMaxLength' | translate: {leftMaxLength: leftMaxLength} }}
          </mat-error>
          <mat-error *ngIf="leftControl.hasError('pattern') && !leftControl.hasError('required')">{{ 'settingsSubjectLocationEditDialog.leftPattern' | translate }}</mat-error>
          <mat-error *ngIf="leftControl.hasError('over') && !leftControl.hasError('pattern') && !leftControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.leftOver' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'settingsSubjectLocationEditDialog.heightPlaceholder' | translate }}</mat-label>
          <input matInput maxlength="{{heightMaxLength}}" [formControl]="heightControl" required
            (focusout)="touchTopControlCheck()">
          <mat-hint align="end">{{heightControl.value?.length || 0}}/{{ heightMaxLength }}</mat-hint>
          <mat-error *ngIf="heightControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.heightRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="heightControl.hasError('maxlength')">{{ 'settingsSubjectLocationEditDialog.heightMaxLength' | translate: {heightMaxLength: heightMaxLength} }}
          </mat-error>
          <mat-error *ngIf="heightControl.hasError('pattern') && !heightControl.hasError('required')">{{ 'settingsSubjectLocationEditDialog.heightPattern' | translate }}</mat-error>
          <mat-error *ngIf="heightControl.hasError('over') && !heightControl.hasError('pattern') && !heightControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.heightOver' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'settingsSubjectLocationEditDialog.widthPlaceholder' | translate }}</mat-label>
          <input matInput maxlength="{{widthMaxLength}}" [formControl]="widthControl" required
            (focusout)="touchLeftControlCheck()">
          <mat-hint align="end">{{widthControl.value?.length || 0}}/{{ widthMaxLength }}</mat-hint>
          <mat-error *ngIf="widthControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.widthRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="widthControl.hasError('maxlength')">{{ 'settingsSubjectLocationEditDialog.widthMaxLength' | translate: {widthMaxLength: widthMaxLength} }}
          </mat-error>
          <mat-error *ngIf="widthControl.hasError('pattern') && !widthControl.hasError('required')">{{ 'settingsSubjectLocationEditDialog.widthPattern' | translate }}</mat-error>
          <mat-error *ngIf="widthControl.hasError('over') && !widthControl.hasError('pattern') && !widthControl.hasError('required')">
            {{ 'settingsSubjectLocationEditDialog.widthOver' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <div fxFlex></div>
    </ng-container>
    <div class="button-div" fxLayout="row" fxLayoutGap="10px">
      <div fxFlex fxLayout="row" fxLayoutAlign="center">
        <button mat-button color="primary" mat-dialog-close>{{ 'settingsSubjectLocationEditDialog.cancel' | translate }}</button>
        <button *ngIf="isFirstLocation" mat-raised-button [disabled]="nameControl.invalid || abbreviationControl.invalid || topControl.invalid || leftControl.invalid
        || heightControl.invalid || widthControl.invalid || isTrans"
          color="primary" (click)="validateIsUpdate()">{{ 'settingsSubjectLocationEditDialog.apply' | translate }}</button>
        <button *ngIf="!isFirstLocation" mat-raised-button [disabled]="nameControl.invalid || abbreviationControl.invalid || isTrans"
          color="primary" (click)="validateIsUpdate()">{{ 'settingsSubjectLocationEditDialog.apply' | translate }}</button>
      </div>
      <button *ngIf="isEdit" mat-raised-button color="warn" (click)="deleteLocation()" [disabled]="locationIndexList.length === 1 && this.subjectModel.locations.length === 1">{{ 'settingsSubjectLocationEditDialog.delete' | translate }}</button>
    </div>
  </div>
</div>
